import { render, staticRenderFns } from "./lainapaikka.vue?vue&type=template&id=1fc2ee9c&"
import script from "./lainapaikka.vue?vue&type=script&lang=js&"
export * from "./lainapaikka.vue?vue&type=script&lang=js&"
import style0 from "./lainapaikka.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports